import type { SortOption } from '../types/SortOption';

export const DEFAULT_SORT_OPTION_VALUE = 'relevance-asc';

export const getSortOptionValue = ({
  descending,
  key,
}: Pick<SortOption, 'descending' | 'key'>): string => {
  return key ? `${key}${descending ? '-desc' : '-asc'}` : DEFAULT_SORT_OPTION_VALUE;
};
